import { Taxonomy } from "@common/categories";
import { useStandardCategories } from "./useStandardCategories";

export function usePersonalCategory() {
    const standardCategories = useStandardCategories();

    return standardCategories[Taxonomy.personal];
}
